import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IParamPosInsatallment } from '../models/models'

export class ListParamPosInsatallmentApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/posTransactionParam/listParamPosInsatallment',
      requesterInfo,
    })
  }

  public async listParamPosInsatallment(): Promise<IParamPosInsatallment[]> {
    return await this.getAsync<IParamPosInsatallment[]>()
  }
}
